import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { CommercialService } from '../../commercial.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';

@Component({
  selector: 'app-cq16',
  templateUrl: './cq16.component.html',
  styleUrls: ['./cq16.component.css', '../commercial-questionnaire.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ])
  ]
})

export class Cq16Component implements OnInit {

  @Input() data: any;
  question;
  questions;
  user_bot = false;
  showbutton = true;
  userResponses = [];
  index;
  questionObj;
  deviceWidth;
  typeOfProduct;
  showTip = true;
  fixed_id;
  variable_id;
  hgProductTypes = {
    type1: false,
    type2: false
  }

  constructor(private commercialService: CommercialService, private ref: ChangeDetectorRef) {
    this.questions = this.commercialService.getQues();
    this.deviceWidth = this.commercialService.deviceWidth;
    this.userResponses = this.commercialService.userResponse.userResponses;
   }

  ngOnInit() {
    this.commercialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.fixed_id = document.getElementById('fixed_mob');
      this.variable_id = document.getElementById('variable_mob');
    } else {
      this.fixed_id = document.getElementById('fixed');
      this.variable_id = document.getElementById('variable');
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'com_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        if (!_.isEmpty(obj.fieldValue)) {
          this.typeOfProduct = obj.fieldValue;
          if (this.typeOfProduct === 'Fixed rate') {
            this.hgProductTypes = {
              type1: true,
              type2: false
            };
            this.showTip = true;
            this.fixed_id.parentElement.classList.add('active-select');
          } else {
            this.variable_id.parentElement.classList.add('active-select');
            this.hgProductTypes = {
              type1: false,
              type2: true
            };
          }
          this.user_bot = true;
          this.showTip = true;
        }
      } else {
        if (_.contains(this.fixed_id.parentElement.classList, 'active-select')) {
          this.fixed_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.variable_id.parentElement.classList, 'active-select')) {
          this.variable_id.parentElement.classList.remove('active-select');
        }
        this.typeOfProduct = '';
        this.user_bot = false;
        this.showTip = false;
      }
      if (this.deviceWidth < 768) {
        this.next();
      }
    }

    if(!this.hgProductTypes.type1 && !this.hgProductTypes.type2)
    {
      this.showbutton = false;
    }
  }

  getProductType(event) {
    if (event.target.checked === true) {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
      if (event.target.value === 'Fixed rate') {
        this.showTip = true;
        this.hgProductTypes = {
          type1: true,
          type2: false
        };
        if (_.contains(this.variable_id.parentElement.classList, 'active-select')) {
          this.variable_id.parentElement.classList.remove('active-select');
        }
        this.fixed_id.parentElement.classList.add('active-select');
        this.typeOfProduct = 'Fixed rate';
        this.save();
      } else {
        this.hgProductTypes = {
          type1: false,
          type2: true
        };
        if (_.contains(this.fixed_id.parentElement.classList, 'active-select')) {
          this.fixed_id.parentElement.classList.remove('active-select');
        }
        this.variable_id.parentElement.classList.add('active-select');
        this.typeOfProduct = 'Variable & index rate';
        this.showTip = true;
        this.save();
      }
      this.user_bot = true;
    } else {
      this.typeOfProduct = '';
      this.hgProductTypes = {
        type1: false,
        type2: false
      };
      if (_.contains(this.fixed_id.parentElement.classList, 'active-select')) {
        this.fixed_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.variable_id.parentElement.classList, 'active-select')) {
        this.variable_id.parentElement.classList.remove('active-select');
      }
      this.user_bot = false;
      this.showTip = false;
    }
    this.save();
    if (this.deviceWidth < 768) {
      this.next();
    }

    if (event.target.checked === true)
    {
      if (this.deviceWidth < 768) {
       
      }else
      {
        if(!this.showbutton)
        {
          this.next();
        }
  
      }

    }
  }

  save() {
    const Obj = {
      'com_question_id': this.data,
      'fieldName': 'product_type',
      'fieldValue': this.typeOfProduct
    };
    this.commercialService.updateResponses(Obj);
  }

  next() {
    if (_.isEmpty(this.typeOfProduct)) {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
    } else {
      this.commercialService.messageService({'currentId': this.data});
    }
  }

}
